import { render } from "./LeaveApply.vue?vue&type=template&id=79813489&scoped=true"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"

import "./LeaveApply.vue?vue&type=style&index=0&id=79813489&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79813489"]])

export default __exports__